#import "../NotifyTimeFields.graphql"
query NotifyTimes(
  $orderBy: [NotifyTimesOrderBy!]
  $first: Int
  $after: Cursor
  $filter: NotifyTimeFilter
) {
  notifyTimes(
    first: $first
    orderBy: $orderBy
    filter: $filter
    after: $after
  ) {
    nodes {
      ...NotifyTimeFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
  }
}
